export const courses = [
  {
    id: 'ai_101',
    title: 'AI-101: Artificial Intelligence Foundations',
    description: 'Comprehensive 3-month intensive covering machine learning, neural networks, and AI ethics',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'ai',
    emoji: '🤖',
    color: '#667eea',
    file: 'ai_101_syllabus.md'
  },
  {
    id: 'neuro_101',
    title: 'NEURO-101: Neuroscience Foundations', 
    description: 'Deep dive into brain structure, function, and cutting-edge neurotechnology',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'neuro',
    emoji: '🧠',
    color: '#764ba2',
    file: 'neuro_101_syllabus.md'
  },
  {
    id: 'auto_101',
    title: 'AUTO-101: Automation Systems',
    description: 'Control theory, robotics, and intelligent automation systems',
    duration: '12 weeks', 
    difficulty: 'Foundational',
    domain: 'auto',
    emoji: '⚙️',
    color: '#f093fb',
    file: 'auto_101_syllabus.md'
  },
  {
    id: 'manuf_101',
    title: 'MANUF-101: Manufacturing & Supply Chain',
    description: 'Raw materials to advanced electronics: supply chain, manufacturing, and system composition',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'manuf', 
    emoji: '🏭',
    color: '#4facfe',
    file: 'manuf_101_syllabus.md'
  },
  {
    id: 'cs_101',
    title: 'CS-101: Computer Science Foundations',
    description: 'Programming, algorithms, data structures, and software engineering principles',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'cs',
    emoji: '💻',
    color: '#06d6a0',
    file: 'cs_101_syllabus.md'
  },
  {
    id: 'bio_101',
    title: 'BIO-101: Biology Foundations',
    description: 'Cell biology, genetics, molecular biology, and evolutionary principles',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'bio',
    emoji: '🧬',
    color: '#ff6b6b',
    file: 'bio_101_syllabus.md'
  },
  {
    id: 'math_101',
    title: 'MATH-101: Advanced Mathematics',
    description: 'Calculus, linear algebra, differential equations, and mathematical analysis',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'math',
    emoji: '📐',
    color: '#4ecdc4',
    file: 'math_101_syllabus.md'
  },
  {
    id: 'phys_101',
    title: 'PHYS-101: Physics Foundations',
    description: 'Classical mechanics, thermodynamics, electromagnetism, and quantum physics',
    duration: '12 weeks',
    difficulty: 'Foundational',
    domain: 'physics',
    emoji: '⚛️',
    color: '#845ec2',
    file: 'phys_101_syllabus.md'
  },
  // Advanced 201-level courses
  {
    id: 'ai_201',
    title: 'AI-201: Advanced Machine Learning',
    description: 'Deep learning, reinforcement learning, and cutting-edge AI research',
    duration: '16 weeks',
    difficulty: 'Advanced',
    domain: 'ai',
    emoji: '🤖',
    color: '#667eea',
    file: 'ai_201_syllabus.md',
    prerequisites: ['ai_101', 'math_101']
  },
  {
    id: 'neuro_201',
    title: 'NEURO-201: Computational Neuroscience',
    description: 'Neural modeling, brain simulation, and neuromorphic computing',
    duration: '16 weeks',
    difficulty: 'Advanced',
    domain: 'neuro',
    emoji: '🧠',
    color: '#764ba2',
    file: 'neuro_201_syllabus.md',
    prerequisites: ['neuro_101', 'math_101']
  },
  {
    id: 'cs_201',
    title: 'CS-201: Advanced Software Engineering',
    description: 'System design, architecture patterns, and large-scale software development',
    duration: '16 weeks',
    difficulty: 'Advanced',
    domain: 'cs',
    emoji: '💻',
    color: '#06d6a0',
    file: 'cs_201_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'bio_201',
    title: 'BIO-201: Advanced Molecular Biology',
    description: 'Genetic engineering, CRISPR, synthetic biology, and bioengineering',
    duration: '16 weeks',
    difficulty: 'Advanced',
    domain: 'bio',
    emoji: '🧬',
    color: '#ff6b6b',
    file: 'bio_201_syllabus.md',
    prerequisites: ['bio_101']
  },
  // Specialized interdisciplinary courses
  {
    id: 'quantum_101',
    title: 'QUANTUM-101: Quantum Computing',
    description: 'Quantum mechanics, quantum algorithms, and quantum programming',
    duration: '14 weeks',
    difficulty: 'Advanced',
    domain: 'quantum',
    emoji: '🔬',
    color: '#9b59b6',
    file: 'quantum_101_syllabus.md',
    prerequisites: ['phys_101', 'math_101', 'cs_101']
  },
  {
    id: 'robotics_101',
    title: 'ROBOTICS-101: Advanced Robotics',
    description: 'Robot design, control systems, computer vision, and autonomous navigation',
    duration: '14 weeks',
    difficulty: 'Advanced',
    domain: 'robotics',
    emoji: '🤖',
    color: '#e74c3c',
    file: 'robotics_101_syllabus.md',
    prerequisites: ['auto_101', 'cs_101', 'math_101']
  },
  {
    id: 'bioai_101',
    title: 'BIOAI-101: Bioinformatics & AI',
    description: 'Machine learning for biology, drug discovery, and genomics analysis',
    duration: '14 weeks',
    difficulty: 'Advanced',
    domain: 'bioai',
    emoji: '🧪',
    color: '#2ecc71',
    file: 'bioai_101_syllabus.md',
    prerequisites: ['ai_101', 'bio_101', 'math_101']
  },
  {
    id: 'data_101',
    title: 'DATA-101: Data Science & Analytics',
    description: 'Big data, statistical analysis, machine learning, and data visualization',
    duration: '12 weeks',
    difficulty: 'Intermediate',
    domain: 'data',
    emoji: '📊',
    color: '#f39c12',
    file: 'data_101_syllabus.md',
    prerequisites: ['math_101', 'cs_101']
  },
  
  // Development & DevOps Courses
  {
    id: 'xcode_101',
    title: 'XCODE-101: Xcode Development Mastery',
    description: 'Complete Xcode IDE mastery: debugging, testing, CI/CD, and advanced development workflows',
    duration: '10 weeks',
    difficulty: 'Intermediate',
    domain: 'ios',
    emoji: '🔨',
    color: '#007AFF',
    file: 'xcode_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'swiftui_101',
    title: 'SWIFTUI-101: Modern iOS App Development',
    description: 'Declarative UI development with SwiftUI: animations, state management, and modern iOS patterns',
    duration: '12 weeks',
    difficulty: 'Intermediate',
    domain: 'ios',
    emoji: '📱',
    color: '#FF9500',
    file: 'swiftui_101_syllabus.md',
    prerequisites: ['xcode_101']
  },
  {
    id: 'uikit_101',
    title: 'UIKIT-101: Traditional iOS Development',
    description: 'UIKit fundamentals: view controllers, navigation, table views, and iOS design patterns',
    duration: '12 weeks',
    difficulty: 'Intermediate',
    domain: 'ios',
    emoji: '📲',
    color: '#34C759',
    file: 'uikit_101_syllabus.md',
    prerequisites: ['xcode_101']
  },
  {
    id: 'onnx_101',
    title: 'ONNX-101: LLM Model Deployment',
    description: 'ONNX runtime, model optimization, quantization, and production LLM deployment strategies',
    duration: '8 weeks',
    difficulty: 'Advanced',
    domain: 'ai',
    emoji: '🧠',
    color: '#FF6B35',
    file: 'onnx_101_syllabus.md',
    prerequisites: ['ai_101', 'cs_101']
  },
  {
    id: 'k8s_101',
    title: 'K8S-101: Kubernetes Container Orchestration',
    description: 'Kubernetes clusters, deployments, services, ingress, monitoring, and production operations',
    duration: '10 weeks',
    difficulty: 'Advanced',
    domain: 'devops',
    emoji: '☸️',
    color: '#326CE5',
    file: 'k8s_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'rbac_101',
    title: 'RBAC-101: Microsoft Enterprise Security',
    description: 'Role-Based Access Control, Azure AD, Microsoft security frameworks, and enterprise identity management',
    duration: '8 weeks',
    difficulty: 'Intermediate',
    domain: 'security',
    emoji: '🔐',
    color: '#0078D4',
    file: 'rbac_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'docker_101',
    title: 'DOCKER-101: Containerization Mastery',
    description: 'Docker containers, images, networking, volumes, Docker Compose, and container best practices',
    duration: '8 weeks',
    difficulty: 'Intermediate',
    domain: 'devops',
    emoji: '🐳',
    color: '#2496ED',
    file: 'docker_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'fastapi_101',
    title: 'FASTAPI-101: Modern Python Web Development',
    description: 'FastAPI framework, async programming, API design, testing, and production deployment',
    duration: '10 weeks',
    difficulty: 'Intermediate',
    domain: 'web',
    emoji: '⚡',
    color: '#009688',
    file: 'fastapi_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'sqlite_101',
    title: 'SQLITE-101: Lightweight Database Management',
    description: 'SQLite database design, optimization, transactions, full-text search, and embedded database patterns',
    duration: '6 weeks',
    difficulty: 'Beginner',
    domain: 'data',
    emoji: '🗄️',
    color: '#003B57',
    file: 'sqlite_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  
  // Additional Professional Development Courses
  {
    id: 'powershell_101',
    title: 'POWERSHELL-101: Scripting & Automation',
    description: 'PowerShell scripting, automation, system administration, and Windows management at scale',
    duration: '8 weeks',
    difficulty: 'Intermediate',
    domain: 'automation',
    emoji: '⚡',
    color: '#012456',
    file: 'powershell_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'sql_101',
    title: 'SQL-101: Database Mastery',
    description: 'SQL fundamentals, query optimization, database design, stored procedures, and performance tuning',
    duration: '10 weeks',
    difficulty: 'Intermediate',
    domain: 'data',
    emoji: '🏛️',
    color: '#336791',
    file: 'sql_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'sentiment_101',
    title: 'SENTIMENT-101: Sentiment Analysis & NLP',
    description: 'Natural Language Processing, sentiment analysis, text mining, and emotion detection systems',
    duration: '10 weeks',
    difficulty: 'Advanced',
    domain: 'ai',
    emoji: '💭',
    color: '#E91E63',
    file: 'sentiment_101_syllabus.md',
    prerequisites: ['ai_101', 'cs_101']
  },
  {
    id: 'qa_101',
    title: 'QA-101: Quality Assurance & Testing',
    description: 'Test planning, automation strategies, quality metrics, and comprehensive software testing methodologies',
    duration: '12 weeks',
    difficulty: 'Intermediate',
    domain: 'testing',
    emoji: '🔍',
    color: '#9C27B0',
    file: 'qa_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'selenium_101',
    title: 'SELENIUM-101: Web Test Automation',
    description: 'Selenium WebDriver, automated testing frameworks, CI/CD integration, and scalable test architecture',
    duration: '8 weeks',
    difficulty: 'Intermediate',
    domain: 'testing',
    emoji: '🕷️',
    color: '#43B02A',
    file: 'selenium_101_syllabus.md',
    prerequisites: ['qa_101', 'cs_101']
  },
  {
    id: 'intellij_101',
    title: 'INTELLIJ-101: IDE Mastery',
    description: 'IntelliJ IDEA productivity, debugging, refactoring, plugins, and advanced development workflows',
    duration: '6 weeks',
    difficulty: 'Beginner',
    domain: 'tools',
    emoji: '🧠',
    color: '#000000',
    file: 'intellij_101_syllabus.md',
    prerequisites: ['cs_101']
  },
  {
    id: 'springboot_101',
    title: 'SPRINGBOOT-101: Enterprise Java Development',
    description: 'Spring Boot framework, microservices, REST APIs, JPA, security, and enterprise application patterns',
    duration: '12 weeks',
    difficulty: 'Advanced',
    domain: 'web',
    emoji: '🍃',
    color: '#6DB33F',
    file: 'springboot_101_syllabus.md',
    prerequisites: ['cs_101', 'sql_101']
  },
  {
    id: 'identity_101',
    title: 'IDENTITY-101: Identity Management Systems',
    description: 'Identity and access management, directory services, SSO, user provisioning, and identity governance',
    duration: '10 weeks',
    difficulty: 'Advanced',
    domain: 'security',
    emoji: '👤',
    color: '#FF5722',
    file: 'identity_101_syllabus.md',
    prerequisites: ['cs_101', 'rbac_101']
  },
  {
    id: 'oauth_101',
    title: 'OAUTH-101: Authentication & Authorization',
    description: 'OAuth 2.0, OpenID Connect, JWT tokens, API security, and modern authentication protocols',
    duration: '8 weeks',
    difficulty: 'Advanced',
    domain: 'security',
    emoji: '🔑',
    color: '#795548',
    file: 'oauth_101_syllabus.md',
    prerequisites: ['cs_101', 'identity_101']
  },
  {
    id: 'n8n_101',
    title: 'N8N-101: Workflow Automation Mastery',
    description: 'Visual workflow automation, API integration, and business process optimization',
    duration: '10 weeks',
    difficulty: 'Foundational',
    domain: 'automation',
    emoji: '⚡',
    color: '#ff6b35',
    file: 'n8n_101_syllabus.md'
  }
];

export const getDomainCourses = (domain) => {
  return courses.filter(course => course.domain === domain);
};

export const getCourseById = (id) => {
  return courses.find(course => course.id === id);
};